import React, { MutableRefObject, PropsWithChildren } from 'react';
import { getChildPages } from '../utils/ConnectedPagesHelperFunctions';
import { Heading } from '../../../Heading/Heading';
import { ConnectedPagesGraphEdges } from './ConnectedPagesGraphEdges';
import { IConnectedPage } from '../../../../../types/api/connectedPages/IConnectedPage';

type ConnectedPagesGraphContainerProps = {
  current: IConnectedPage;
  headlineLevel: number;
  headline: string;
  containerDimensions: { width: number; height: number };
  connectedPagesGraphContainer: MutableRefObject<HTMLUListElement | null>;
  currentSet: number;
  maxPagesPerRow: number;
  parentPageWidth: number;
  activeCustomActionButton?: string;
  radiusOfNodeSphere: number;
};

export function ConnectedPagesGraphContainer({
  current,
  headlineLevel,
  headline,
  containerDimensions,
  connectedPagesGraphContainer,
  currentSet,
  maxPagesPerRow,
  parentPageWidth,
  activeCustomActionButton,
  radiusOfNodeSphere,
  children,
}: PropsWithChildren<ConnectedPagesGraphContainerProps>) {
  return (
    <nav
      className="connected-pages-graph__container"
      aria-labelledby="connected-pages-graph-container"
      style={{
        height: containerDimensions.width,
      }}
    >
      <Heading hierarchy={headlineLevel} className="invisible" id="connected-pages-graph-container">
        {headline}
      </Heading>
      <ul className="connected-pages-graph__list" ref={connectedPagesGraphContainer}>
        {children}
      </ul>

      <ConnectedPagesGraphEdges
        containerDimensions={containerDimensions}
        parentPageWidth={parentPageWidth}
        childPages={!activeCustomActionButton ? getChildPages(current, currentSet, maxPagesPerRow) : []}
        maxPagesPerRow={maxPagesPerRow}
        radiusOfFirstRow={radiusOfNodeSphere}
      />
    </nav>
  );
}
